import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-progress-bar-simple',
  standalone: true,
  templateUrl: './progress-bar-simple.component.html',
  styleUrls: ['./progress-bar-simple.component.scss']
})
export class ProgressBarSimpleComponent implements OnInit {
  @Input() score: number;
  @Input() height = 15;
  constructor() { }

  ngOnInit(): void {
  }

  getScore() {
    if (!this.score) {
      return 0 + '%';
    } else {
      return this.score + '%';
    }
  }
}
